import { superstyled } from '@zenbusiness/zui/styles';

export const Root = superstyled({
  name: 'AppFooter',
  styles: {
    display: 'flex',
    alignItems: 'start',
    gap: '0.75rem',
    flexDirection: 'column',
    margin: '0 auto',
    maxWidth: '1440px',
    paddingBlock: '1.5rem',
    textAlign: 'justify'
  }
});
